import React, { useState, useEffect, useCallback, useMemo } from "react";
import { StyleSheet, View, TouchableOpacity } from "react-native";
import { FormControlLabel, Button } from "src/components";
import { colors } from "src/assets";
import LocalText from "src/local";
import TextField from "@mui/material/TextField";
import InputBase from "@mui/material/InputBase";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

export type BirthdayProps = {
  value?: string;
  error?: string;
  onChange: (value?: string) => void;
};

const buildDetail = (v?: string) => {
  if (v) {
    const date = new Date(v);
    return `${date.getFullYear()}年${`${date.getMonth() + 1}`.padStart(
      2,
      "0"
    )}月${`${date.getDate()}`.padStart(2, "0")}日`;
  }

  return LocalText.common.unselected;
};

export const Birthday: React.FC<BirthdayProps> = ({
  value,
  error,
  onChange,
}) => {
  const [date, setDate] = useState<Date>(value ? new Date(value) : new Date());
  const [showPopover, setShowPopover] = useState<boolean>(false);
  const maxDate = useMemo(() => {
    const localDate = new Date();
    localDate.setFullYear(localDate.getFullYear() - 20);
    return localDate;
  }, []);
  useEffect(() => {
    setDate(value ? new Date(value) : new Date());
  }, [value]);

  return (
    <React.Fragment>
      <FormControlLabel
        text={LocalText.screens.myProfile.birthday.title}
        helper={LocalText.screens.myProfile.birthday.helper}
        detailRender={
          <DesktopDatePicker
            inputFormat="yyyy年MM月dd日"
            maxDate={maxDate}
            value={value}
            onChange={(localDate) => {
              if (localDate && !Number.isNaN(localDate.getTime())) {
                setDate(localDate);
                onChange(localDate.toISOString());
              }
            }}
            renderInput={(params) => (
              <InputBase
                type="text"
                inputRef={params.inputRef}
                inputProps={{
                  ...params.inputProps,
                  placeholder: "1990年01月01日",
                }}
                value={params.value}
                onClick={params.onClick}
                onChange={params.onChange}
                endAdornment={params.InputProps?.endAdornment}
              />
            )}
          />
        }
        rightIcon={"chevron"}
        error={error}
        onPress={() => setShowPopover(true)}
      />
    </React.Fragment>
  );
};
